import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@monorepo-projects/inf-commons-lib';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
